<template>
  <div class="contractors-info__inviting-modal">
    <HKLModal
      ref="modal"
      :title="$t('hint.inviteAllUsers')"
      okBtnAction="yesInvite"
      @onOkClick="saveAndSendInviteEmails"
    >
      <div class="invite-user__slot">
        <div
          v-if="shouldInvitedMainContractors.length"
          class="invite-users__body"
        >
          <div class="invite-users__title">
            {{ $t('mainContractor') }}
          </div>
          <ul class="invite-users__list">
            <li
              v-for="item in shouldInvitedMainContractors"
              :key="item.id"
            >
              {{ item.primaryContact.email }}
            </li>
          </ul>
        </div>
        <br>
        <div
          v-if="shouldInvitedSubContractors.length"
          class="invite-users__body"
        >
          <div class="invite-users__title">
            {{ $t('subContractorWithS') }}
          </div>
          <ul class="invite-users__list">
            <li
              v-for="item in shouldInvitedSubContractors"
              :key="item.id"
            >
              {{ item.primaryContact.email }}
            </li>
          </ul>
        </div>
      </div>
    </HKLModal>
  </div>
</template>

<script>
import { unref } from '@vue/composition-api'
import HKLModal from '@/controls/Modal/HKLModal.vue'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useRouteParamId } from '@/router/useRouter'
import { useStoreActions, useStoreGetters } from '@/store'
import { useShouldInviteMainContractors, useShouldInviteSubContractors } from './contractors.hook'
import { inviteProjectContractors } from './contractors.utils'
/**
 * @type {import('vue').Component}
 */
export default {
  components: {
    HKLModal,
  },
  props: {
    canInvite: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    const projectId = useRouteParamId()
    const { currentMainContractor, currentContractors, isTms } = useStoreGetters('projectContractors', ['currentMainContractor', 'currentContractors', 'isTms'])
    const { loadTenantProject } = useStoreActions('tenantProject', ['loadTenantProject'])
    const { loadProject } = useStoreActions('projects', ['loadProject'])
    const modalHook = useRefModal()
    const shouldInvitedMainContractors = useShouldInviteMainContractors(currentMainContractor)
    const shouldInvitedSubContractors = useShouldInviteSubContractors(currentContractors)
    return {
      ...modalHook,
      shouldInvitedMainContractors,
      shouldInvitedSubContractors,
      saveAndSendInviteEmails: async () => {
        if (props.canInvite) {
          await Promise.all([...unref(shouldInvitedMainContractors), ...unref(shouldInvitedSubContractors)].map(async item => {
            await inviteProjectContractors(isTms, projectId, item)
          }))
        }
        if (unref(isTms)) {
          await loadTenantProject(unref(projectId))
        } else {
          await loadProject(unref(projectId))
        }
      },
    }
  },
}
</script>
